import { memo } from 'react';
import { Users } from 'lucide-react';
import { BaseNode, type NodeData } from './BaseNode';

function CustomerNodeComponent({ data, selected }: { data: NodeData; selected?: boolean }) {
  return <BaseNode data={data} selected={selected} icon={Users} nodeType="customer" />;
}

export const CustomerNode = memo(CustomerNodeComponent);
